/* Public Firebase web config; shared by the app and the service worker */
export const firebaseConfig = {
  apiKey: "AIzaSyBhiwzr5iPGY5sqSjKCPMo_5SYa4mgIHwQ",
  authDomain: "bcm-anesthesia-app.firebaseapp.com",
  projectId: "bcm-anesthesia-app",
  storageBucket: "bcm-anesthesia-app.firebasestorage.app",
  messagingSenderId: "829202354227",
  appId: "1:829202354227:web:d04ef3938e179ad7339346",
  measurementId: "G-7V9W3C9G1C"
};
